if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class MediaGallery extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                liveRegion: this.querySelector('[id^="GalleryStatus"]'),
                viewer: this.querySelector('[id^="GalleryViewer"]'),
                thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
                thumbnails2: this.querySelector('[id^="GalleryThumbnails2"]')
            }
            this.mql = window.matchMedia('(min-width: 750px)');
            if (!this.elements.thumbnails) return;

            this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
            this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
                mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false))
            });
            if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
            this.initDot()
            this.dotChange()
            this.elements.viewer
                .querySelector(".prevButton")
                .addEventListener("click", () => {
                    this.prevSlide();
                });
            this.elements.viewer
                .querySelector(".nextButton")
                .addEventListener("click", () => {
                    this.nextSlide();
                });
            this.querySelectorAll(".mediaSwitchBox .tab-item").forEach((tab) => {
                tab.addEventListener("click", () => {
                    this.switchMediaGroup(tab.dataset.type);
                });
            });
            // 窗口尺寸变化后视频/3D 的高度锁定值失效，清除后待下次切换重新锁定
            window.addEventListener("resize", debounce(() => {
                const mediaList = this.elements.viewer.querySelector("ul");
                if (mediaList) mediaList.style.minHeight = "";
            }, 200));
            this.syncSwitchTab(this.elements.viewer.querySelector("li.is-active"));
        }

        // Photos / Video / 3D 切换：跳转到对应类型的第一张媒体
        switchMediaGroup(type) {
            const targetSlide = this.elements.viewer.querySelector(`li[data-media-group="${type}"]`);
            if (!targetSlide) return;
            this.setActiveMedia(targetSlide.dataset.mediaId, false);
        }

        // 当前主图属于哪个类型，对应 tab 高亮；主图为视频/3D时禁用左右切换热区
        syncSwitchTab(activeMedia) {
            if (!activeMedia) return;
            const group = activeMedia.dataset.mediaGroup || "photos";
            const zoneBox = this.querySelector(".setButtonIcon");
            if (zoneBox) zoneBox.classList.toggle("media-zone-disabled", group !== "photos");
            const tabs = this.querySelectorAll(".mediaSwitchBox .tab-item");
            if (!tabs.length) return;
            tabs.forEach((tab) => {
                tab.classList.toggle("selected", tab.dataset.type === group);
            });
        }

        // ≤1032 且主图为视频/3D时：thumbnail 布局下其余图片 slide 会被 display:none，
        // 列表高度塌陷成视频自身高度；锁定切换前的列表高度，让视频/3D 在原图片区域内垂直居中（对齐 PC 端表现）
        syncMediaListHeight(activeMedia, mediaList, previousListHeight) {
            if (!mediaList) return;
            const isSpecialMedia = activeMedia.dataset.mediaGroup && activeMedia.dataset.mediaGroup !== "photos";
            if (!isSpecialMedia || window.matchMedia("(min-width: 1033px)").matches) {
                mediaList.style.minHeight = "";
                return;
            }
            if (previousListHeight > 0) mediaList.style.minHeight = `${previousListHeight}px`;
        }

        initDot() {
            const slides2 = this.elements.thumbnails2.querySelectorAll("li");
            const initializeIndex = 0;
            this.elements.thumbnails2.querySelectorAll("li").forEach((element) => {
                element.classList.remove('is-active');
            })
            const initializeDot = slides2[initializeIndex];

            initializeDot.classList.add('is-active');
        }

        dotChange() {
            this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
                mediaToSwitch.querySelector('button').addEventListener('click', () => {
                    const slides2 = this.elements.thumbnails2.querySelectorAll("li");
                    const dotIndex = Array.prototype.indexOf.call(mediaToSwitch.parentElement.children, mediaToSwitch)
                    const nextSlide2 = slides2[dotIndex];
                    this.elements.thumbnails2.querySelectorAll("li").forEach((element) => {
                        element.classList.remove('is-active');
                    })
                    nextSlide2.classList.add('is-active');
                })
            });
        }
        // 相邻切换目标：在图片集合内循环（视频/3D 缩略图不展示，切换也跳过它们）；
        // 最后一张图片再下一张 → 有视频进视频，无视频回第一张图片；
        // 第一张图片点上一张 → 有3D进3D，无3D有视频进视频，都没有则回最后一张图片。
        // 圆点高亮统一由 setActiveMedia 按缩略图是否存在同步（视频/3D 无缩略图则保持原高亮）
        getAdjacentSlide(direction) {
            const slides = Array.from(this.elements.viewer.querySelectorAll("li"));
            if (!slides.length) return null;
            const currentSlide = slides.find((element) => element.classList.contains("is-active")) || slides[0];
            // 主图为视频/3D时不可用左右切换（与热区禁用态配套，兜底键盘等触发路径）
            if (currentSlide.dataset.mediaGroup && currentSlide.dataset.mediaGroup !== "photos") return null;

            const photoSlides = slides.filter((element) => (element.dataset.mediaGroup || "photos") === "photos");
            if (!photoSlides.length) return null;
            const currentPhotoIndex = photoSlides.indexOf(currentSlide);
            if (currentPhotoIndex === -1) {
                return direction === "next" ? photoSlides[0] : photoSlides[photoSlides.length - 1];
            }

            if (direction === "next") {
                if (currentPhotoIndex < photoSlides.length - 1) return photoSlides[currentPhotoIndex + 1];
                const videoSlide = slides.find((element) => element.dataset.mediaGroup === "video");
                return videoSlide || photoSlides[0];
            }

            if (currentPhotoIndex > 0) return photoSlides[currentPhotoIndex - 1];
            const modelSlide = slides.find((element) => element.dataset.mediaGroup === "3d");
            if (modelSlide) return modelSlide;
            const videoSlide = slides.find((element) => element.dataset.mediaGroup === "video");
            return videoSlide || photoSlides[photoSlides.length - 1];
        }

        // 切换下一张的逻辑
        nextSlide() {
            const targetSlide = this.getAdjacentSlide("next");
            if (!targetSlide) return;
            this.setActiveMedia(targetSlide.dataset.mediaId, false);
        }

        // 切换上一张的逻辑
        prevSlide() {
            const targetSlide = this.getAdjacentSlide("prev");
            if (!targetSlide) return;
            this.setActiveMedia(targetSlide.dataset.mediaId, false);
        }

        onSlideChanged(event) {
            const currentElement = event.detail.currentElement;
            if (!currentElement) return;
            const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${currentElement.dataset.mediaId}"]`);
            // 主图被原生滑动切换（≤749px 左右滑）时，同步主图 is-active 与圆点高亮，
            // 避免与点击切换（.setButtonIcon / 缩略图）的状态脱节；不主动滚动主图，防止与手势抢占
            this.syncActiveState(currentElement, thumbnail);
            this.setActiveThumbnail(thumbnail);
        }

        syncActiveState(activeMedia, thumbnail) {
            this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
                element.classList.remove('is-active');
            });
            activeMedia.classList.add('is-active');
            this.syncSwitchTab(activeMedia);
            if (!thumbnail || !this.elements.thumbnails2) return;
            const dotIndex = Array.prototype.indexOf.call(thumbnail.parentElement.children, thumbnail);
            const dots = this.elements.thumbnails2.querySelectorAll('li');
            dots.forEach((element) => element.classList.remove('is-active'));
            if (dots[dotIndex]) dots[dotIndex].classList.add('is-active');
        }

        setActiveMedia(mediaId, prepend) {
            // 添加空值检查
            if (!mediaId) {
                console.error('mediaId is null or undefined');
                return;
            }

            const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

            // 添加元素存在性检查
            if (!activeMedia) {
                console.error(`Media element with data-media-id="${mediaId}" not found`);
                return;
            }

            // 切换前记录列表高度：≥750 的 thumbnail 布局里非激活图片 slide 会被 display:none，
            // 切到视频/3D 后列表高度会塌陷，需以此高度做锁定
            const mediaList = this.elements.viewer.querySelector("ul");
            const previousListHeight = mediaList ? mediaList.offsetHeight : 0;

            this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
                element.classList.remove('is-active');
            });
            activeMedia.classList.add('is-active');
            this.syncSwitchTab(activeMedia);
            this.syncMediaListHeight(activeMedia, mediaList, previousListHeight);
            // PC 端主图无横向滚动、不触发 slideChanged，圆点需在此直接同步；
            // 按缩略图在列表中的实际位置取索引（data-media-position 是按媒体类型分别计数的，视频/3D 会错位）
            if (this.elements.thumbnails2) {
                const dotThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
                if (dotThumbnail) {
                    const dotIndex = Array.prototype.indexOf.call(dotThumbnail.parentElement.children, dotThumbnail);
                    const dots = this.elements.thumbnails2.querySelectorAll('li');
                    dots.forEach((element) => element.classList.remove('is-active'));
                    if (dots[dotIndex]) dots[dotIndex].classList.add('is-active');
                }
            }

            if (prepend) {
                activeMedia.parentElement.prepend(activeMedia);
                if (this.elements.thumbnails) {
                    const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
                    activeThumbnail.parentElement.prepend(activeThumbnail);
                }
                if (this.elements.viewer.slider) this.elements.viewer.resetPages();
            }

            this.preventStickyHeader();
            window.setTimeout(() => {
                if (this.elements.thumbnails) {
                    activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
                }
                if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
                    activeMedia.scrollIntoView({ behavior: 'smooth' });
                }
            });
            this.playActiveMedia(activeMedia);

            if (!this.elements.thumbnails) return;
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            this.setActiveThumbnail(activeThumbnail);
            // 视频/3D 缩略图不展示时 activeThumbnail 为空
            if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }

        setActiveThumbnail(thumbnail) {
            if (!this.elements.thumbnails || !thumbnail) return;

            this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
            thumbnail.querySelector('button').setAttribute('aria-current', true);
            if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

            // 竖排缩略图（slider-responsive-component，PC 端 >1032px）按 Y 轴滚动；横排保持原有 X 轴滚动
            if (typeof this.elements.thumbnails.isVertical === 'function' && this.elements.thumbnails.isVertical()) {
                this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
            } else {
                this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
            }
        }

        announceLiveRegion(activeItem, position) {
            const image = activeItem.querySelector('.product__modal-opener--image img');
            if (!image) return;
            image.onload = () => {
                this.elements.liveRegion.setAttribute('aria-hidden', false);
                this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
                    '[index]',
                    position
                );
                setTimeout(() => {
                    this.elements.liveRegion.setAttribute('aria-hidden', true);
                }, 2000);
            };
            image.src = image.src;
        }

        playActiveMedia(activeItem) {
            window.pauseAllMedia();
            const deferredMedia = activeItem.querySelector('.deferred-media');
            if (!deferredMedia) return;
            deferredMedia.loadContent(false);
            // 切到视频媒体时尝试自动播放，被浏览器策略拦截时静默失败
            const video = deferredMedia.querySelector('video');
            if (video) video.play().catch(() => {});
        }

        preventStickyHeader() {
            this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
            if (!this.stickyHeader) return;
            this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }

        removeListSemantic() {
            if (!this.elements.viewer.slider) return;
            this.elements.viewer.slider.setAttribute('role', 'presentation');
            this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
        }
    });
}
